
<template>
    <div v-if="!is_mem_load">
        <div class="intro">
            <legend>{{this.mem_type}}</legend>
            
            <div class="memorandum_info row">
                <div class="col-lg-6 col-sm-12">
                    <mem_block_left
                        @edit_links="edit_links"
                        @edit_title="edit_text('mem_title')">
                    </mem_block_left>
                    
                    <mem_links_edit></mem_links_edit>
                </div>
                
                <div class="col-lg-6 col-sm-12 right_no_form_style">
                    <mem_block_right></mem_block_right>
                </div>
            </div>
        </div>
        
        <div class="memorandum_work_block memorandum_info">
            <div class="memorandum_info dani">
                <legend>Данi</legend>
                <mem_text @edit_text="edit_text('mem_pre')" key="pre_text" label="Преамбула" :text="mem_pre"></mem_text>
                <mem_text @edit_text="edit_text('mem_problem')" key="problem" label="Проблема" :text="mem_problem"></mem_text>
                <mem_text @edit_text="edit_text('mem_result')" key="result" label="Запропоноване рішення" :text="mem_result"></mem_text>
            </div>
        </div>
        
        <div class="addon_data" v-if="this.memorandum.hasOwnProperty('addon_data')">
            <component :addon_data="memorandum.addon_data" :mem="memorandum" v-bind:is="cur_addon_component" ></component>
        </div>
        
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import Mem_block_left from "./sides/mem_block_left.vue";
import Mem_block_right from "./sides/mem_block_right.vue";
import Mem_text from "./sides/helpers/mem_text.vue";
import mem_links_edit from "./editor/mem_links_edit.vue";

//Addons
import mem_inside_bill from "./addon/bill/mem_inside_bill.vue";
import mem_inside_kadru from "./addon/kadru/mem_inside_kadru.vue";
import mem_inside_land from "./addon/land/mem_inside_land.vue";
import mem_inside_tender from "./addon/tender/mem_inside_tender.vue";
import mem_inside_dogovor from "./addon/agreement/mem_inside_dogovor.vue";
import mem_inside_trip from "./addon/trip/mem_inside_trip.vue";
import mem_inside_vacation from "./addon/vacation/mem_inside_vacation.vue";
import mem_inside_parts_reserv from "./addon/parts_reserv/mem_inside_part_reserv.vue";
import mem_inside_parts from "./addon/parts/mem_inside_parts.vue";


export default {
    name: "mem_block",
    components: {
        Mem_text,
        mem_links_edit,
        Mem_block_right,
        Mem_block_left,
        mem_inside_bill,
        mem_inside_kadru,
        mem_inside_land,
        mem_inside_tender,
        mem_inside_dogovor,
        mem_inside_trip,
        mem_inside_vacation,
        mem_inside_parts_reserv,
        mem_inside_parts
    },
    
    created() {
        EventBus.$on('finish_edit',this.edit_finish);
    },
    
    methods : {
        
        edit_finish(event) {
            console.log('%c ✔ Memorandum Edit Finish:',"color: #148f32",event);
            let mem_id = this.memorandum.id;
            const [parsedType, memorandumId] = event.uniq.split('|');
            
            if(parseInt(memorandumId) === parseInt(mem_id)) {
                api.patch('/memorandums/' + mem_id + '/text', {
                    "field_type" : parsedType,
                    "field_val" : event.text,
                }).then(({data}) => {
                    if (data.status === 'operation_success') {
                        EventBus.$emit("reload_mem", {"mem_id": mem_id});
                    }
                }).catch(err => {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            }
        },
        
        edit_links() {
            console.log('%c ✔ Memorandum Edit Links:',"color: #148f32");
            this.edit_text('links');
        },
        
        edit_text(type) {
            if (this.$options.computed && this.$options.computed.hasOwnProperty(type)) {
                console.log('%c ✔ Memorandum Edit Text:',"color: #148f32",type);
                IMC_CORE.showloading();
                
                this.get_rights().then(({data}) => {
                    IMC_CORE.hideloading();
                    if (data.status === 'operation_success') {
                        if (type === 'links') {
                            EventBus.$emit('load_links_editor', {
                                'mem_id': this.memorandum.id,
                            });
                        } else {
                            EventBus.$emit('load_editor', {
                                'message': this[type],
                                'uniq': type + '|' + this.memorandum.id,
                            });
                        }
                    }
                }).catch(err => {
                    IMC_CORE.hideloading();
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            }
        },
        
        get_rights() {
            return api.get('/memorandums/' + this.memorandum.id + '/rights')
        },
    },
    
    computed: {
        ...mapGetters({
            'memorandum': "memorandum_inside/getMemorandum",
            'is_mem_load': "memorandum_inside/is_load"
        }),
        
        cur_addon() {
            if(this.memorandum.hasOwnProperty("addon")) {
                return this.memorandum.addon;
            }
            return "";
        },
        
        cur_addon_component() {
            if(this.cur_addon.length > 0) {
                return 'mem_inside_' + this.cur_addon;
            }
            
            return '';
        },
        
        mem_type() {
            if(this.memorandum.hasOwnProperty("def_type")) {
                return this.memorandum.def_type;
            }
            return "";
        },
        
        mem_title() {
            if(this.memorandum.hasOwnProperty("title")) {
                return this.memorandum.title;
            }
            
            return "";
        },
        
        mem_problem() {
            if(this.memorandum.hasOwnProperty("problem")) {
                return this.memorandum.problem;
            }
            
            return "";
        },
        
        mem_result() {
            if(this.memorandum.hasOwnProperty("result")) {
                return this.memorandum.result;
            }
            
            return "";
        },
        
        mem_pre() {
            if(this.memorandum.hasOwnProperty("pre_text")) {
                return this.memorandum.pre_text;
            }
            
            return "";
        },
        
        links() {
        
        },
        
    },
    
}
</script>

<style scoped>

</style>